<template>
  <div class="users-list-wrapper mb-4">
    <form @submit.prevent="search"
          class="sticky-top px-3 px-md-0 bg-white"
          v-if="searchable">
      <div class="d-flex flex-column pt-2 px-3">
        <div class="input-group has-clearable w-100 d-flex align-items-center">
          <button @click="clearSearch" aria-label="Close" class="close show" type="button">
            <span aria-hidden="true"><i class="fa fa-times-circle"/></span>
          </button>
          
          <label class="input-group-prepend align-middle" for="query">
            <span class="input-group-text d-block mt-1 mr-2">
                <span class="fas fa-search"/>
            </span>
          </label>
          
          <input @keyup="search"
                 class="form-control position-relative flex-grow-1 min-w-0 mb-0 text-base outline-none pl-1"
                 id="query"
                 placeholder="Buscar usuario"
                 ref="query"
                 type="text"
                 v-model="query">
        </div>
      </div>
    </form>
    
    <ul class="teams list-group list-group-flush" v-if="(!loading || loadingMore)">
      <li :key="user.id"
          :user="user"
          :is-selected="userSelected(user)"
          class="list-group-item"
          is="user-list-item"
          v-bind="$props"
          v-for="user in users"/>
    </ul>
    
    <div class="w-100 text-center mt-3" v-if="(loading || loadingMore)">
      <div class="spinner-border text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    
    <div class="text-center my-4" v-if="pageable && !updateOnScroll"
         v-show="(!loading && !loadingMore)">
      <button :disabled="loading || numUsers < pageSize"
              @click="loadMore"
              class="btn btn-light btn-load-more"
              ref="load-more-button"
              type="button">
        <i class="fa fa-fw fa-angle-double-down"/>
        Cargar más
      </button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { find } from 'lodash'
  import UserListItem from './UserListItem'
  import 'select2/dist/js/select2.min.js'
  
  const ENTER = 13
  const ESC   = 27
  
  export default {
    name: 'UsersList',
    components: {
      UserListItem,
    },
    props: {
      ...UserListItem.props,
      
      users: {
        type: Array,
        default: () => ([]),
      },
      selectedUsers: {
        type: Array,
        default: () => ([]),
      },
      searchable: {
        type: Boolean,
        default: true,
      },
      pageable: {
        type: Boolean,
        default: true,
      },
      isPublication: {
        type: Boolean,
        default: false,
      },
      updateOnScroll: {
        type: Boolean,
        default: false,
      },
      pageSize: {
        type: Number,
        default: 20,
      },
      loadUsersFunction: {
        type: Function,
        default: null,
      },
    },
    data () {
      return {
        loading: false,
        loadingMore: false,
        query: null,
        page: 1,
        currentUsers: [],
        currentPage: null,
        sendingInvitation: false,
      }
    },
    methods: {
      async load (params = {}) {
        if (!this.loadUsersFunction) {
          throw new Error('loadUserFunction not defined.')
        }
        
        params = {
          ...params,
          ...{
            page: this.page,
            query: this.query,
          },
        }
        
        this.loading = true
        
        await this.loadUsersFunction(params)
        
        this.loading = false
      },
      async loadMore () {
        if (!this.loadUsersFunction) {
          throw new Error('loadUserFunction not defined.')
        }
        
        this.loadingMore = true
        this.page += 1
        
        await this.loadUsersFunction({
          page: this.page,
          query: this.query,
        })
        
        this.loadingMore = false
      },
      async search (e) {
        const key = e.which || e.keyCode
        
        if (key === ESC) {
          this.clearSearch()
          
          return
        }
        
        if (!this.loadUsersFunction || !this.query || key !== ENTER) {
          return
        }
        
        // Backup users before searching.
        if (this.currentUsers.length === 0) {
          this.currentUsers = this.users
          this.currentPage  = this.page
        }
        
        this.loading = true
        this.page    = 1
        
        await this.loadUsersFunction({
          query: this.query,
          page: this.page,
        })
        
        this.loading = false
      },
      clearSearch () {
        if (!this.query) {
          return
        }
        
        this.query = ''
        
        this.users = this.currentUsers
        this.page  = this.currentPage
        
        // Reset current users array.
        this.currentUsers = []
        this.currentPage  = null
      },
      userSelected (user) {
        const selected = find(this.selectedUsers, u => u.id === user.id)
        
        return selected !== null && selected !== undefined
      },
    },
    computed: {
      ...mapGetters({
        numUsers: 'users/numUsers',
      }),
    },
    mounted () {},
  }
</script>
